import { ResponseStoreFrontProductSearchFacet } from '@/src/interfaces/data-contracts';

export type FiltersType = ResponseStoreFrontProductSearchFacet & { Order?: string };

export function generateQueryString(filters: FiltersType): string {
  const queryParameters: string[] = [];
  const seenParameters = new Set<string>();
  const { Order, ...otherFilters } = filters;

  for (const [key, values] of Object.entries(otherFilters)) {
    if (Array.isArray(values)) {
      values.forEach((value) => {
        // @ts-ignore
        const keyValueString = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        if (!seenParameters.has(keyValueString)) {
          queryParameters.push(keyValueString);
          seenParameters.add(keyValueString);
        }
      });
    }
  }

  if (Order !== undefined) {
    queryParameters.push(`Order=${encodeURIComponent(Order)}`);
  }

  return queryParameters.join('&');
}
